module.exports = __webpack_public_path__ + "img/52200.34c54d34.jpg";